<table *ngIf="sortedHistory$ | async as history" mat-table [dataSource]="history.protocolHistories" class="w-100">
  <ng-container matColumnDef="investigator">
    <th mat-header-cell *matHeaderCellDef> Principal Investigator </th>
    <td mat-cell *matCellDef="let element">
      <!-- Display Researcher name if exists, otherwise Option (ApplicationUser) name as fallback -->
      {{ element?.principalInvestigator 
         ? (element.principalInvestigator.lastName + ', ' + element.principalInvestigator.firstName)
         : (element?.investigator ? (element.investigator.firstName + ' ' + element.investigator.lastName) : '')
      }} 
    </td>
  </ng-container>

  <ng-container matColumnDef="created">
    <th mat-header-cell *matHeaderCellDef> Date </th>
    <td mat-cell *matCellDef="let element"> {{ element?.created | date:'shortDate' }} </td>
  </ng-container>

  <ng-container matColumnDef="createdBy">
    <th mat-header-cell *matHeaderCellDef> CreatedBy </th>
    <td mat-cell *matCellDef="let element"> {{ element?.createdBy || '' }} </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element"><button mat-stroked-button color="accent"
        (click)="view(element)">View</button></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
